import { t } from "@/language/translation";
export default function joinList(strings: string[], maxNumberOfItems = 3) {
  if (strings.length > maxNumberOfItems) {
    return `${strings.filter((_, index) => index < maxNumberOfItems).join(", ")}, +${
      strings.length - maxNumberOfItems
    } ${t("global.joinList.more")}`;
  }
  return strings.join(", ");
}
